import React from 'react';

const StockInfo = ({ stock, setStock, enableVariants, showGeneratedVariants, generatedVariants }) => {
  return (
    <div className="sm:col-span-2">
      <label htmlFor="stock" className="block text-sm font-medium text-gray-700 mb-1">
        Stock <span className="text-red-500">*</span>
        {enableVariants && showGeneratedVariants && generatedVariants.length > 0 && (
          <span className="text-xs text-gray-500 ml-2">(Calculé automatiquement)</span>
        )}
      </label>
      <div className="mt-1">
        <input
          type="number"
          name="stock"
          id="stock"
          min="0"
          value={stock}
          onChange={(e) => setStock(e.target.value)}
          className={`block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md ${
            enableVariants && showGeneratedVariants && generatedVariants.length > 0
              ? 'bg-gray-100'
              : ''
          }`}
          placeholder="0"
          required
          readOnly={enableVariants && showGeneratedVariants && generatedVariants.length > 0}
        />
      </div>
    </div>
  );
};

export default StockInfo;